import { render, staticRenderFns } from "./pr_view.vue?vue&type=template&id=49cd2890"
import script from "./pr_view.vue?vue&type=script&lang=js"
export * from "./pr_view.vue?vue&type=script&lang=js"
import style0 from "./pr_view.vue?vue&type=style&index=0&id=49cd2890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports